import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import KeywordDefinitionDeleteUI from './keyworddefinitiondeleteui';

export default class KeywordDefinitionDelete extends Plugin {
  static get pluginName() {
    return 'KeywordDefinitionDelete';
  }

  static get requires() {
    return [ KeywordDefinitionDeleteUI ];
  }
}